export default __webpack_public_path__ + "static/media/entrefox_badge.a2e72b3d.png";